import { PageItemApi } from 'api/PageItemApi';
import { backendApiClient } from 'container/backendApiClient';

export const pageItemApi: PageItemApi = new PageItemApi(backendApiClient);
